// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeOptInsModel {
    static getAttributeTypeMap() {
        return SimpleIntakeOptInsModel.attributeTypeMap;
    }
}
SimpleIntakeOptInsModel.discriminator = undefined;
SimpleIntakeOptInsModel.additionalProperties = false;
SimpleIntakeOptInsModel.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "boolean"
    },
    {
        "name": "mail",
        "baseName": "mail",
        "type": "boolean"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "boolean"
    },
    {
        "name": "text",
        "baseName": "text",
        "type": "boolean"
    },
];
//# sourceMappingURL=simpleIntakeOptInsModel.js.map